var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSkills = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E0A93F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24L25 13.5302L21.4 9H10.6L7 13.5302L16 24ZM16.0591 19.9851L14.8991 14.4052H17.3915L16.0591 19.9851ZM19.1907 14.4052L18.1332 18.8339L21.9401 14.4052H19.1907ZM22.0694 12.6552H19.232L18.8903 10.75H20.5554L22.0694 12.6552ZM17.1124 10.75H15.2202L14.8726 12.6552H17.4541L17.1124 10.75ZM13.0937 12.6552L13.4413 10.75H11.4446L9.93062 12.6552H13.0937ZM10.0599 14.4052H13.1117L14.0852 19.0878L10.0599 14.4052Z",
    fill: "#E0A93F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSkills, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/skills.53b23811.svg";
export { ForwardRef as ReactComponent };